export default "__VITE_ASSET__Dit0Pj4Z__"